import * as React from "react";
import {GridColDef} from "@mui/x-data-grid";
import {formatTime} from "@/helper/method";
import {ProTable} from "@/widget/ProTable/ProTable";
import {ForeheadPageVO, useQueryForeheadPage} from "@/service/forehead.s";
import {useAuthInfo} from "@/store/account.c";
import {WriteForehead} from "@/pages/Forehead/WriteForehead";
import {ViewForehead} from "@/pages/Forehead/ViewForehead";

export const ForeheadListPage = () => {
    const {
        mutate: foreheadPageMutate,
        data: foreheadPageData,
        isPending: foreheadPagePending,
    } = useQueryForeheadPage()
    const {id} = useAuthInfo()

    const columns: GridColDef<ForeheadPageVO>[] = [
        {field: "invoiceTitle", headerName: "发票抬头", flex: 0.6, minWidth: 120},
        {
            field: "depositBank",
            headerName: "开户行",
            flex: 0.5,
        },
        {
            field: "depositAccount",
            headerName: "开户账户",
            headerAlign: "center",
            align: "center",
            flex: 0.6,
        },
        {
            field: "taxNumber",
            headerName: "纳税识别号",
            headerAlign: "center",
            align: "center",
            flex: 0.6,
        },
        {
            field: "mobile",
            headerName: "电话",
            headerAlign: "center",
            align: "center",
            flex: 0.6,
            valueFormatter: (value: string) => value || "-"
        },
        {
            field: "createdAt",
            headerName: "创建时间",
            headerAlign: "center",
            align: "center",
            flex: 0.4,
            valueFormatter: (value) => formatTime("D", value) || "-"
        },
    ];

    return (
        <ProTable<ForeheadPageVO>
            loading={foreheadPagePending}
            renderDrawer={{view: <ViewForehead/>, write: <WriteForehead/>}}
            columns={columns}
            data={foreheadPageData?.data}
            drawerProps={{
                view: {
                    hiddenFooter: true,
                }
            }}
            onSearch={(params) => {
                foreheadPageMutate(params);
            }}
            code={"forehead"}
        />
    );
};
